export const MEDICATION_MODES = {
  CREATION: "creation",
  VIEW: "view",
  EDIT: "edit",
} as const

export type MedicationMode = (typeof MEDICATION_MODES)[keyof typeof MEDICATION_MODES] | null
